export default "__VITE_ASSET__3a00e943__"